import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MbenzCaptureResponseComponent } from './mbenz-capture-response.component';

import { MbenzPayStudentComponent } from './mbenz-pay-student.component';
import { MbenzPaylayoutComponent } from './mbenz-paylayout.component';

const routes: Routes = [
  {
    path: '',
    component: MbenzPaylayoutComponent,
    children: [
      {
        path: 'mbenzCaptureResponse',
        component: MbenzCaptureResponseComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MbenzFeePaymentRoutingModule {}
